import React, { useState, useEffect } from 'react';

interface CookieConsentProps {
  onAccept: () => void;
  onDecline: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onDecline }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
    onDecline();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-purple-300 shadow-lg z-50">
      <div className="max-w-4xl mx-auto p-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-oswald font-bold text-gray-900 mb-2">
              Cookie Consent
            </h3>
            <p className="text-sm text-gray-700 font-lora">
              We use cookies to analyze site usage and improve your experience. 
              This helps us understand how visitors interact with our game and make it better.
            </p>
            <p className="text-xs text-gray-600 mt-2">
              <a href="/privacy" className="text-purple-600 hover:text-purple-800 underline">
                Privacy Policy
              </a>
              {' • '}
              <a href="/cookies" className="text-purple-600 hover:text-purple-800 underline">
                Cookie Policy
              </a>
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-sm font-oswald font-medium text-gray-700 bg-gray-200 hover:bg-gray-300 rounded transition-colors duration-200"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm font-oswald font-medium text-white bg-purple-600 hover:bg-purple-700 rounded transition-colors duration-200"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
